export const viewOrderArr = [{
  display: 'Profile',
  displaySubmitted: 'Contact Information',
  hideSubNavSubmitted: false,
  key: 'Profile',
  showInactivePipeline: true,
  showUnqualified: true,
  subNav: [{
    display: 'Contact Information',
    key: 'Contact Information'
  }, {
    display: 'Preliminary Information',
    key: 'Preliminary Information'
  }]
}, {
  display: 'APPLICATION Instructions',
  key: 'Instructions',
  showUnqualified: false,
}, {
  display: 'Preferences',
  key: 'Preferences',
  subNav: [{
    display: 'Availability Information',
    key: 'Availability Information'
  }, {
    display: 'Home Office Setup',
    key: 'Home Office Setup'
  }]
}, {
  display: 'Experience',
  key: 'Experience',
  subNav: [{
    display: 'Career Summary',
    key: 'Career Summary'
  }, {
    display: 'Work Experience',
    key: 'Work Experience'
  }, {
    display: 'Employment Gaps',
    key: 'Employment Gaps'
  }]
}, {
  display: 'Skills',
  key: 'Skills',
  subNav: [{
    display: 'Introduction',
    key: 'Instructions'
  }, {
    display: 'Industry Segments',
    key: 'Industry Segment'
  }, {
    display: 'Firm Types',
    key: 'Types of Firms or Organizations worked for'
  }, {
    display: 'Positions',
    key: 'Positions or Types of Work'
  }, {
    display: 'Departments',
    key: 'Departments'
  }, {
    display: 'Special Areas',
    key: 'Special Areas of Knowledge'
  }, {
    display: 'Mgmt Systems',
    key: 'Management Systems'
  }, {
    display: 'Computer Skills',
    key: 'Computer Skills'
  }, {
    display: 'Rating Systems',
    key: 'Rating Systems'
  }, {
    display: 'Languages',
    key: 'Foreign Languages'
  }]
}, {
  display: 'Summary of Skills',
  key: 'Summary of Skills',
  subNav: [{
    display: 'Summary of Skills',
    key: 'Summary of Skills'
  }]
}, {
  display: 'Background',
  key: 'Background',
  subNav: [{
    display: 'Education',
    key: 'Education'
  }, {
    display: 'Licenses',
    key: 'Licenses'
  }, {
    display: 'Professional Designations',
    key: 'Professional Designations'
  }, {
    display: 'Professional Associations',
    key: 'Professional Associations'
  }, {
    display: 'Additional Professional References',
    key: 'Additional Professional References'
  }]
}, {
  display: 'Documents',
  key: 'Documents'
}, {
  display: 'Submit',
  key: 'Submit',
  hideSubmitted: true,
}];



// WEBPACK FOOTER //
// ./shared/react/r_ApplicantDashboard/viewOrderArr.js